// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".initl-cont[data-v-260478be]{white-space:nowrap;overflow:hidden;width:100%;text-overflow:ellipsis}.initl-frmt[data-v-260478be]{width:75px;display:inline-block;font-family:monospace}", ""]);
// Exports
module.exports = exports;
